import { render, staticRenderFns } from "./protocolcontrol.vue?vue&type=template&id=56543780&scoped=true&"
import script from "./protocolcontrol.vue?vue&type=script&lang=js&"
export * from "./protocolcontrol.vue?vue&type=script&lang=js&"
import style0 from "./protocolcontrol.vue?vue&type=style&index=0&id=56543780&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56543780",
  null
  
)

export default component.exports